import { __rest } from '../../_virtual/_tslib.esm.js';
import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const PulseIcon = (_a) => {
    var props = __rest(_a, []);
    return (React__default.createElement(SvgIcon, Object.assign({ width: "32", height: "32", viewBox: "0 0 17 16" }, props),
        React__default.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default.createElement("path", { d: "M0 10.5H2.41886C2.46615 10.5 2.50697 10.4669 2.51672 10.4206L4.40301 1.4607C4.42526 1.35503 4.57602 1.35476 4.59865 1.46035L7.42027 14.6279C7.44181 14.7285 7.58283 14.7349 7.6135 14.6368L9.91926 7.25836C9.94697 7.1697 10.07 7.16342 10.1066 7.24879L11.474 10.4394C11.4898 10.4762 11.5259 10.5 11.5659 10.5H15.5", stroke: "#2C3341" }),
            React__default.createElement("circle", { cx: "15", cy: "10.5", r: "1.5" }))));
};

export { PulseIcon as default };
